import {
  TranscriptSegment,
  TranscriptWord,
} from '@app/routes/content/routes/recordings/domain';

/**
 * Returns word-level timing for a transcript segment.
 *
 * If `segment.words` is present and non-empty, it is returned directly.
 * Otherwise the segment text is split on whitespace and the segment's time
 * range is divided equally across all words (confidence score defaults to 1.0).
 */
export const generateWordsFromSegment = (
  segment: TranscriptSegment,
): TranscriptWord[] => {
  if (segment.words && segment.words.length > 0) {
    return segment.words;
  }

  const rawWords = segment.text.trim().split(/\s+/).filter(Boolean);
  if (rawWords.length === 0) return [];

  const duration = segment.end - segment.start;

  return rawWords.map((word, i) => ({
    word,
    start: segment.start + (i / rawWords.length) * duration,
    end: segment.start + ((i + 1) / rawWords.length) * duration,
    score: 1.0,
  }));
};
